/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { ErrorModel } from '../model/error.model';
import { ErrorSeverityEnum } from '../consts/error-severity.enum';

@Directive({
  selector: '[iriroCustomRequiredTrue], [customRequiredTrue]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: CustomRequiredTrueValidator,
      multi: true,
    }
  ]
})

export class CustomRequiredTrueValidator implements Validator {
  @Input('customRequiredTrue') fieldName = '';

  validate(control: AbstractControl): ErrorModel | null {
    const funcProperties = {
      field: this.fieldName
    }
    return _customRequiredTrueValidation.bind(funcProperties)(control);
  }
}

export const customRequiredTrueValidation = (fieldName: ''): ValidatorFn => {
  const funcProperties = {
    field: fieldName
  }

  return _customRequiredTrueValidation.bind(funcProperties);
}

function _customRequiredTrueValidation(this: any, control: AbstractControl): ErrorModel | null {
  let errors: ErrorModel | null = null;

  if(
    control.value === null ||
    control.value === undefined ||
    control.value === false
  ) {
    errors = {
      severity: ErrorSeverityEnum.error,
      message: 'required' + this.field
    }
  }

  return errors;
}

